import { useState, useEffect } from 'react';
import { _Kpi } from '../../../../core/services/dataBean/EntityCatalogVdos';
import usePaginator from '../../../theme/Component/usePaginator';
import { SelectProccessTypeConstants } from '../../../erp/cellEditor/CashRequest/FactoryDocument/SelectProccessTypeConstants';
import { BasicButton } from '../../../theme/Component/BasicButton';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_LG } from '../../../theme/Component/hooks/useModal';
import { Modal } from '../../../theme/Component/Modal';
import { BasicTable } from '../../../theme/Component/BasicTable';
import { AccountEditor } from '../../../editor/AccountEditor';
import { SelectFunctionalID } from '../../../admin/configuracion/functionalID/SelectFunctionalID';
import { StrategicObjectiveEditor } from '../StrategicObjetive/StrategicObjective.editor';
import { StrategicObjectiveEditortwo } from '../StrategicObjetive/StrategicObjectiveEditortwo';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const KpiEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_Kpi)
    const [id, setID] = useState(null);
    const [form, setForm] = useState<any>({
        IDProductionResource: null,
        Name: null,
        IDLnFunctionalID: null,
        Account: null
    })
    const modal = useModal("KPI", MODAL_LG);
    const [regexStr, setregexStr] = useState<any>(null)
    const [processType, setprocessType] = useState<number>(null)
    const paginador = usePaginator();
    useEffect(() => {
        setID(idSelector)
    }, [idSelector])



    useEffect(() => {
        getLista();
    }, [paginador.page])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDKpi == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };



    const getLista = () => {

        instance.getKpiCatalog(processType, form.IDProductionResource, form.IDLnFunctionalID, form.Account, null, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        )

    }
    const head = [
        { title: 'ID', property: 'IDKpi', visible: true },
        { title: 'Tipo de Proceso', property: 'ProcessTypeName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Clase JAVA', property: 'ClassForName', visible: true },
        { title: 'Fecha Creacion', property: 'Since', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "KPI"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                        <SelectProccessTypeConstants idSelector={processType} onChange={(e) => { setprocessType(e) }} />
                    </div>
                    <div className="col-md-6">
                        <StrategicObjectiveEditortwo render={form.Name} idSelector={form.IDProductionResource} onChange={(e) => { setForm({ ...form, "IDStrategicObjective": e.IDStrategicObjective, "Name": e.Name }) }} label=" " returnType="Object" />
                    </div>
                    <div className="col-md-6">
                        <SelectFunctionalID label='Area Organizacional' functionalIDLn={form.IDLnFunctionalID} onChange={(e: any) => { setForm({ ...form, "IDLnFunctionalID": e.IDLn }) }} />
                    </div>
                    <div className="col-md-6">
                        <AccountEditor idAccount={form.Account} onChange={(e: any) => { setForm({ ...form, "Account": e.IDAccount }) }} label="Responsable del Indicador" />
                    </div>
                    <div className="col-md-6">
                        <label>Búsqueda por Texto</label>
                        <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-6">
                        <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                            Consultar
                        </BasicButton>
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDKpi); modal.close(); }} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
            </Modal>
        </>
    )
}